var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 32,
    viewBox: "0 0 145 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8066 18.738L28.6621 18.5932L41.9012 2.68652C41.9155 2.73591 41.9252 2.78654 41.9301 2.83774C41.9301 3.64852 41.9301 4.44643 41.9301 5.27007C41.9256 5.35612 41.8916 5.43796 41.8337 5.50173C40.7032 6.65998 39.5705 7.81716 38.4356 8.97327L35.5482 11.9043C34.2314 13.247 32.9135 14.5865 31.5945 15.9228C30.7616 16.77 29.9286 17.6173 29.0957 18.4645C29.009 18.545 28.9062 18.6286 28.8066 18.738Z",
    fill: "url(#paint0_linear_3566_267)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0439 18.8988L41.0175 7.27441C41.0175 7.42241 41.0175 7.5125 41.0175 7.59615C41.0175 8.06911 41.0175 8.54528 41.0175 9.02145C41.0126 9.14335 40.9608 9.25863 40.873 9.34319C38.8903 10.9948 36.9096 12.6431 34.9312 14.2883C33.0705 15.8369 31.2108 17.3845 29.3523 18.931C29.227 19.0243 29.1499 19.0854 29.0439 18.8988Z",
    fill: "url(#paint1_linear_3566_267)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9418 10.8779C39.9418 11.4378 39.9418 11.9268 39.9418 12.4126C39.9216 12.4706 39.8803 12.5189 39.8262 12.5477L35.6508 15.3243L30.9776 18.442C30.5505 18.7251 30.1201 19.005 29.6929 19.2914C29.5677 19.3782 29.4938 19.3525 29.4199 19.2174L39.9418 10.8779Z",
    fill: "url(#paint2_linear_3566_267)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8154 19.5359L38.3074 14.2529C38.3074 14.7355 38.2849 15.1731 38.3074 15.6074C38.3215 15.6991 38.301 15.7927 38.2499 15.87C38.1988 15.9473 38.1209 16.0028 38.0312 16.0257C35.404 17.2118 32.7778 18.4055 30.1527 19.6066C30.0274 19.6646 29.9054 19.7353 29.8154 19.5359Z",
    fill: "url(#paint3_linear_3566_267)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0375 23.1942H69.844C67.5379 23.1942 66.3838 21.4611 66.3817 17.9949C66.3795 14.5287 67.5336 12.7935 69.844 12.7892H78.5159L81.975 5.85254H69.844C62.9194 5.85254 59.457 9.89999 59.457 17.9949C59.457 26.0898 62.9194 30.1362 69.844 30.1341H81.9621V17.9949H75.0375V23.1942Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.152 22.2611C104.721 20.9999 106.02 18.4593 106.048 14.6392C106.055 13.4882 105.835 12.3471 105.4 11.2816C104.966 10.216 104.325 9.24711 103.515 8.43052C102.705 7.61392 101.742 6.96577 100.682 6.52334C99.6207 6.08091 98.4831 5.85294 97.334 5.85254H85.2705V12.7892H97.3886C98.5449 12.7892 99.1219 13.3705 99.1198 14.533C99.1105 14.9973 98.9188 15.4391 98.5862 15.7626C98.2537 16.0861 97.8072 16.2651 97.3437 16.2607H85.2705V30.1341H92.1952V19.7291L99.5662 30.1341H108.238L102.152 22.2611Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.482 5.85254H109.558V30.1308H116.482V5.85254Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M133.289 5.85547H121.178V30.1338H133.289C140.214 30.1338 143.676 26.0874 143.676 17.9946C143.676 9.90185 140.214 5.85547 133.289 5.85547ZM133.289 23.1971H128.102V12.7889H133.289C135.596 12.7889 136.75 14.5241 136.752 17.9946C136.754 21.4651 135.6 23.1993 133.289 23.1971Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0775 13.9472C22.0523 13.5517 22.0007 13.1583 21.9233 12.7696C21.8646 12.4774 21.7906 12.1885 21.7017 11.9041C21.1428 10.1476 20.0404 8.61474 18.5542 7.52735C17.068 6.43996 15.275 5.85443 13.4345 5.85547H1.31641V30.1338H8.24105V23.1971H13.4345C18.3893 23.1971 21.2157 21.0651 21.9137 16.801C21.9683 16.4985 22.0036 16.1865 22.0325 15.8615C22.0486 15.6974 22.0582 15.5398 22.0679 15.3692C22.0839 15.0893 22.0903 14.7998 22.0903 14.5038V14.3879C22.0903 14.2367 22.0839 14.0919 22.0775 13.9472ZM13.3864 16.2605H8.24747V12.7889H13.4345C14.5876 12.7889 15.1689 13.3713 15.1657 14.5327C15.1556 14.9973 14.9631 15.4391 14.6301 15.7625C14.297 16.0859 13.8502 16.2648 13.3864 16.2605Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1547 7.54483H32.0155V6.78552C32.0155 6.52953 31.914 6.28403 31.7333 6.10302C31.5526 5.922 31.3075 5.82031 31.052 5.82031H25.8745C25.619 5.82031 25.3739 5.922 25.1932 6.10302C25.0125 6.28403 24.911 6.52953 24.911 6.78552V7.873H24.8339C24.7749 7.87384 24.7185 7.89794 24.677 7.94009C24.6355 7.98223 24.6123 8.03904 24.6123 8.09821V9.00873C24.6123 9.06761 24.6357 9.12407 24.6772 9.16571C24.7188 9.20734 24.7751 9.23073 24.8339 9.23073H24.911V11.4121C24.911 11.6681 25.0125 11.9136 25.1932 12.0946C25.3739 12.2756 25.619 12.3773 25.8745 12.3773H31.0455C31.3011 12.3773 31.5462 12.2756 31.7269 12.0946C31.9076 11.9136 32.0091 11.6681 32.0091 11.4121V9.56855H30.8657V7.8183C30.8661 7.78113 30.8739 7.74442 30.8888 7.71035C30.9037 7.67629 30.9252 7.64558 30.9522 7.62006C30.9792 7.59453 31.011 7.57472 31.0458 7.56179C31.0806 7.54886 31.1177 7.54309 31.1547 7.54483ZM27.8241 7.8183C27.8241 7.74577 27.8529 7.67621 27.9041 7.62492C27.9553 7.57364 28.0247 7.54483 28.0971 7.54483H29.0607C29.1331 7.54483 29.2025 7.57364 29.2537 7.62492C29.3049 7.67621 29.3337 7.74577 29.3337 7.8183V9.56855H27.808L27.8241 7.8183ZM31.0359 10.7365C31.0478 10.7365 31.0593 10.7412 31.0677 10.7497C31.0761 10.7581 31.0809 10.7696 31.0809 10.7815V11.0357C31.0813 11.0681 31.0753 11.1002 31.0632 11.1302C31.0511 11.1603 31.0332 11.1876 31.0105 11.2107C30.9878 11.2337 30.9608 11.252 30.9309 11.2645C30.9011 11.277 30.8691 11.2834 30.8368 11.2834H29.3915C29.3591 11.2834 29.3271 11.277 29.2973 11.2645C29.2675 11.252 29.2404 11.2337 29.2177 11.2107C29.195 11.1876 29.1771 11.1603 29.165 11.1302C29.1529 11.1002 29.1469 11.0681 29.1474 11.0357V10.7815C29.1469 10.7757 29.1477 10.77 29.1496 10.7645C29.1515 10.7591 29.1545 10.7541 29.1584 10.7498C29.1623 10.7456 29.1671 10.7422 29.1724 10.7399C29.1777 10.7376 29.1834 10.7364 29.1891 10.7365H31.0359Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9715 13.4614H25.9515C25.6959 13.4614 25.4508 13.5631 25.2701 13.7441C25.0894 13.9251 24.9879 14.1706 24.9879 14.4266V26.6655C24.9738 27.1297 25.0529 27.5919 25.2205 28.0249C25.388 28.4578 25.6407 28.8527 25.9634 29.186C26.2862 29.5193 26.6725 29.7843 27.0994 29.9653C27.5263 30.1462 27.9851 30.2395 28.4486 30.2395C28.9122 30.2395 29.371 30.1462 29.7979 29.9653C30.2248 29.7843 30.6111 29.5193 30.9339 29.186C31.2566 28.8527 31.5093 28.4578 31.6768 28.0249C31.8444 27.5919 31.9235 27.1297 31.9094 26.6655V14.417C31.907 14.1671 31.8079 13.9278 31.633 13.7496C31.458 13.5714 31.2209 13.4681 30.9715 13.4614Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2011 5.85259H37.083V12.7892H49.2011C50.3574 12.7892 50.9344 13.3705 50.9323 14.5331C50.923 14.9973 50.7313 15.4391 50.3987 15.7626C50.0662 16.0861 49.6197 16.2651 49.1562 16.2608H37.083V30.1341H44.0012V23.1942H49.1947C55.0145 23.1942 57.9051 20.2578 57.8666 14.3851C57.8353 12.1062 56.9076 9.93177 55.2851 8.33414C53.6626 6.73651 51.4762 5.84475 49.2011 5.85259Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4947 5.37927C27.7014 5.37927 25.1191 5.33745 25.1191 4.80658C25.1191 4.27571 27.6886 4.23389 28.4947 4.23389C29.3009 4.23389 31.8671 4.27571 31.8671 4.80658C31.8671 5.33745 29.2848 5.37927 28.4947 5.37927ZM25.4339 4.80658C25.7101 4.94493 26.815 5.1058 28.4947 5.1058C30.1745 5.1058 31.2762 4.94493 31.5524 4.80658C31.2762 4.67145 30.1713 4.50736 28.4947 4.50736C26.8182 4.50736 25.7101 4.67145 25.4339 4.80658Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6213 17.9174L27.7691 17.7758L14.5364 1.86914C14.5245 1.91891 14.5159 1.96943 14.5107 2.02036C14.5107 2.83114 14.5107 3.62904 14.5107 4.45269C14.5152 4.53874 14.5492 4.62058 14.6071 4.68434C15.7441 5.85118 16.8811 7.00836 18.018 8.15589L20.8765 11.0773C22.1977 12.4157 23.5156 13.7552 24.8303 15.0958C25.6653 15.9409 26.4983 16.7881 27.329 17.6375L27.6213 17.9174Z",
    fill: "url(#paint4_linear_3566_267)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3967 18.0814C23.4141 14.2206 19.4411 10.3597 15.4199 6.45703C15.4199 6.60181 15.4199 6.69512 15.4199 6.77877C15.4199 7.25494 15.4199 7.74398 15.4199 8.20728C15.4271 8.32866 15.4785 8.44317 15.5645 8.52902C17.5451 10.1806 19.53 11.8279 21.5191 13.4709L27.0884 18.1136C27.1976 18.2069 27.3004 18.2648 27.3967 18.0814Z",
    fill: "url(#paint5_linear_3566_267)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4961 10.0605C16.4961 10.6204 16.4961 11.1062 16.4961 11.5952C16.4961 11.6467 16.5571 11.7078 16.6053 11.74L20.7806 14.5166L25.4506 17.6246C25.8778 17.9077 26.3081 18.1844 26.7353 18.474C26.8606 18.5608 26.9345 18.5351 27.0051 18.4C23.5267 15.633 20.0387 12.8693 16.4961 10.0605Z",
    fill: "url(#paint6_linear_3566_267)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6258 18.7185L18.1338 13.4355C18.1338 13.9182 18.1531 14.3525 18.1338 14.7901C18.1205 14.8816 18.1413 14.9748 18.1923 15.052C18.2432 15.1291 18.3207 15.1848 18.41 15.2083C21.0394 16.3966 23.6656 17.5902 26.2886 18.7893C26.4106 18.844 26.5327 18.9147 26.6258 18.7185Z",
    fill: "url(#paint7_linear_3566_267)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3566_267",
    x1: 33.4991,
    y1: 7.54476,
    x2: 37.1733,
    y2: 13.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3566_267",
    x1: 34.0158,
    y1: 11.3251,
    x2: 36.1476,
    y2: 15.0154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3566_267",
    x1: 34.1959,
    y1: 14.2015,
    x2: 35.2746,
    y2: 16.0692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3566_267",
    x1: 33.9811,
    y1: 16.756,
    x2: 34.6831,
    y2: 17.9712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3566_267",
    x1: 14.5107,
    y1: 9.89327,
    x2: 27.7787,
    y2: 9.89327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3566_267",
    x1: 15.4135,
    y1: 12.3287,
    x2: 27.3967,
    y2: 12.3287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3566_267",
    x1: 16.4961,
    y1: 14.2914,
    x2: 27.0115,
    y2: 14.2914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3566_267",
    x1: 18.1306,
    y1: 16.1414,
    x2: 26.6258,
    y2: 16.1414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.24afddebf5b44ca8097e45d23a84bbbb.svg";
export { ForwardRef as ReactComponent };